const S="SESSION_STORAGE_TOKEN",E="assumeSession";export{E as COOKIE_SESSION_NAME,S as SESSION_STORAGE_TOKEN};
//# sourceMappingURL=constants.js.map
